import React from 'react'
import './styles.css'
import mok from '../../../assets/pictures/mok.webp'

const AlliesInsurance = () => {
  return (
    <div className='contain-allies-insurance'>
        <button>
            <div className='contain-text-allies-insurance'>
                <h3>Conoce las tarifas que te traemos para tu seguro de viaje junto a nuestro aliado MOK</h3>
                <p>Te mostramos el portafolio de tarifas, para que tengas todo en cuenta</p>
            </div>
            <img src={mok} alt="" />
        </button>
    </div>
  )
}

export default AlliesInsurance